import { render } from "./ActualizarFechaVence.vue?vue&type=template&id=7931d24a&scoped=true"
import script from "./ActualizarFechaVence.vue?vue&type=script&lang=js"
export * from "./ActualizarFechaVence.vue?vue&type=script&lang=js"

import "./ActualizarFechaVence.vue?vue&type=style&index=0&id=7931d24a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7931d24a"]])

export default __exports__